import React, { useEffect, useState } from 'react';

const AccessControl = ({ children, allowExternal = false }) => {
	const [isAllowed, setIsAllowed] = useState(false);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState('');


	useEffect(() => {
		const checkUserAccess = async () => {
			try {
				console.log('Fetching user profile...');
				const profileRes = await fetch('https://api.hgcdental.clinic/api/profile', { credentials: 'include' });
				const profileData = await profileRes.json();
				console.log('Profile:', profileData);

				const userEmail = profileData.email;

				// 🔹 Ensure internal user check actually matches the email
				const internalRes = await fetch(`https://api.hgcdental.clinic/api/internalusers`, { credentials: 'include' });
				const internalData = await internalRes.json();
				const isInternalUser = internalData.some(user => user.email === userEmail); // ✅ Explicitly check email

				if (isInternalUser) {
					console.log('User is internal, setting access allowed');
					setIsAllowed(true);
					setLoading(false);
					return;
				}

				// 🔹 External user check
				const externalRes = await fetch(`https://api.hgcdental.clinic/api/externalusers`, { credentials: 'include' });
				const externalData = await externalRes.json();
				const isExternalUser = externalData.some(user => user.email === userEmail); // ✅ Explicitly check email

				if (isExternalUser) {
					if (allowExternal) {
						console.log('User is external and access is allowed.');
						setIsAllowed(true);
					} else {
						console.log('User is external but not allowed.');
						setError('External users are not allowed to access this page');
					}
					setLoading(false);
					return;
				}

				setError('User not found');
				setLoading(false);
			} catch (err) {
				console.error('Access check error:', err);
				setError('Error fetching user profile');
				setLoading(false);
			}
		};

		checkUserAccess();
	}, [allowExternal]);


	if (loading) return <div>Loading...</div>;
	if (error) return <div>{error}</div>;
	if (!isAllowed) return <div>Access Denied. You do not have permission to view this page.</div>;

	return children;
};

export default AccessControl;
